import { render, staticRenderFns } from "./MeasurementsStats.vue?vue&type=template&id=5b769dd7"
import script from "./MeasurementsStats.vue?vue&type=script&lang=ts"
export * from "./MeasurementsStats.vue?vue&type=script&lang=ts"
import style0 from "./MeasurementsStats.vue?vue&type=style&index=0&id=5b769dd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports